import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useRegistersChartsDataContext } from './hooks/useRegistersChartsDataContext';

export const Indicators = () => {
    const { chartData } = useRegistersChartsDataContext();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Card
                title="Novos Cadastros"
                value={number.formatToBRNumber(
                    chartData?.indicators?.newRegisters || 0
                )}
            />
            <Card
                title="Atualizações"
                value={number.formatToBRNumber(
                    chartData?.indicators?.updates || 0
                )}
            />
            <Card
                title="Recusa"
                value={number.formatToBRNumber(
                    chartData?.indicators?.refusal || 0
                )}
            />
        </div>
    );
};
